import React, { useState } from 'react'

import { useSelector } from 'react-redux';
import { selectportfolio } from '../../reducers/resumeSlice';
import PortfoliIso from './portfolioIso';
import LoderPortfolioIso from './LoderPortfolioIso';
import PortfoliIsoTop from './PortfoliIsoTop';


export default function Portfolio() {

    const portfolioInfo = useSelector(selectportfolio)
    // console.log(portfolioInfo);


    return (

        <section data-id="portfolio" className="animated-section portfolio">
            {/* <!-- start section-content --> */}
            <div className="section-content">
                <div className="page-title">
                    <h2>نمونه کارها</h2>
                    <h4>بهترین نمونه کارها</h4>
                </div>
                {/* {portfolioInfo !== null ? <PortfoliIso portfolioInfo={portfolioInfo} /> : <LoderPortfolioIso />} */}
                {portfolioInfo !== null ? <PortfoliIsoTop portfolioInfo={portfolioInfo} /> : <LoderPortfolioIso />}
            </div>
            {/* end section-content  */}
        </section>

    )
}
